import httpClient from './httpClient'

const END_POINT = '/reporting/buyer'

/**
 * Buyer-set call disposition: sale state and agent note on a call (ReportingService
 * CallDispositionController). Shared by Call Logs and the softphone wrap-up. The call id goes in the
 * body because Ringba call ids may contain '|'.
 */
const CallDispositionAPI = {
  /**
   * Report (sale: true) or undo (sale: false) a sale on a call.
   *
   * @param {string} accountId - The buyer account ID
   * @param {{ callId: string, sale: boolean, source: 'CallLogs' | 'Softphone' }} payload
   */
  async setSale(accountId, { callId, sale, source }) {
    return await httpClient.post(`${END_POINT}/${accountId}/calls/sale`, {
      callId,
      sale,
      source
    })
  },

  /**
   * Set the agent note on a call: up to 1000 characters; null or blank clears it.
   *
   * @param {string} accountId - The buyer account ID
   * @param {{ callId: string, agentNote: ?string }} payload
   */
  async setAgentNote(accountId, { callId, agentNote }) {
    return await httpClient.put(`${END_POINT}/${accountId}/calls/agent-note`, {
      callId,
      agentNote
    })
  }
}

export default CallDispositionAPI
